import * as Sentry from '@sentry/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import { evaluateTwilioCustomerProfile } from 'api/admin/businesses/twilioIntegration';
import { TwilioCustomerProfileEvaluationHttpResponse } from 'types/twilio/twilioCustomerProfile';

export const useEvaluateTwilioCustomerProfile = () => {
  const queryClient = useQueryClient();

  return useMutation<
  TwilioCustomerProfileEvaluationHttpResponse,
    AxiosError<{ error: string }>,
    {
      businessId: number;
      customerProfileId: string;
    }
  >({
    mutationFn: async ({ businessId, customerProfileId }) => {
      return (await evaluateTwilioCustomerProfile(businessId, customerProfileId)).data;
    },
    onError: (error) => {
      Sentry.captureException(error);
      toaster(
        error?.response?.data?.error ?? 'An error occurred during customer profile evaluation',
        {
          icon: '❌',
        },
      );
    },
  });
};
